import { render, staticRenderFns } from "./WorkspaceNotFound.vue?vue&type=template&id=120dd363"
import script from "./WorkspaceNotFound.vue?vue&type=script&lang=ts"
export * from "./WorkspaceNotFound.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports